// extracted by css-extract-rspack-plugin
export default {"PieChartContainer":"fcEhN"};